<ape-input-wrapper
  [showLabel]="showLabel"
  [label]="label"
  [inputId]="id"
  [isMandatory]="isMandatory"
  [hasInfoIcon]="hasInfoIcon"
  [infoIconTitle]="infoIconTitle"
  [disclaimer]="disclaimer"
  [invalid]="invalid"
  [valid]="valid"
  [readOnly]="readOnly"
>
  <ng-container [ngSwitch]="size">
    <p-multiselect
      *ngSwitchCase="'large'"
      [id]="id"
      [name]="id"
      [optionLabel]="optionLabel"
      [dataKey]="dataKey"
      [options]="options"
      [(ngModel)]="selectedOptions"
      (ngModelChange)="onSelectionChange($event)"
      [placeholder]="placeholder"
      [ngClass]="{
        'ape-multi-select w-full': true,
        'valid': valid,
        'invalid': invalid,
        'read-only': readOnly
      }"
      [disabled]="disabled"
      [variant]="variant"
      [showClear]="showClear"
      [filter]="filter"
      [maxSelectedLabels]="maxSelectedLabels"
      [selectedItemsLabel]="selectedItemsLabel"
      [selectionLimit]="selectionLimit"
      (onPanelHide)="onPanelClosed()"
      size="large"
    >
      <!-- Template per le opzioni selezionate -->
      <ng-template
        #selectedItems
        let-selectedOptions
      >
        <ng-container *ngIf="selectedTemplate; else defaultSelectedTemplate">
          <ng-container *ngTemplateOutlet="selectedTemplate; context: { $implicit: selectedOptions }" />
        </ng-container>
        <ng-template #defaultSelectedTemplate>
          <div *ngFor="let option of selectedOptions; trackBy: trackByFn">
            <span>{{ option?.[optionLabel || 'label'] }}</span>
          </div>
        </ng-template>
      </ng-template>

      <!-- Template per le opzioni nella lista -->
      <ng-template
        #item
        let-option
      >
        <ng-container *ngIf="optionTemplate; else defaultOptionTemplate">
          <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }" />
        </ng-container>
        <ng-template #defaultOptionTemplate>
          <span>{{ option[optionLabel || 'label'] }}</span>
        </ng-template>
      </ng-template>
    </p-multiselect>

    <p-multiselect
      *ngSwitchCase="'small'"
      [id]="id"
      [name]="id"
      [optionLabel]="optionLabel"
      [dataKey]="dataKey"
      [options]="options"
      [(ngModel)]="selectedOptions"
      (ngModelChange)="onSelectionChange($event)"
      [placeholder]="placeholder"
      [ngClass]="{
        'ape-multi-select w-full': true,
        'valid': valid,
        'invalid': invalid,
        'read-only': readOnly
      }"
      [disabled]="disabled"
      [variant]="variant"
      [showClear]="showClear"
      [filter]="filter"
      [maxSelectedLabels]="maxSelectedLabels"
      [selectedItemsLabel]="selectedItemsLabel"
      [selectionLimit]="selectionLimit"
      (onPanelHide)="onPanelClosed()"
      size="small"
    >

      <!-- Template per le opzioni selezionate -->
      <ng-template
        #selectedItems
        let-selectedOptions
      >
        <ng-container *ngIf="selectedTemplate; else defaultSelectedTemplate">
          <ng-container *ngTemplateOutlet="selectedTemplate; context: { $implicit: selectedOptions }" />
        </ng-container>
        <ng-template #defaultSelectedTemplate>
          <div *ngFor="let option of selectedOptions; trackBy: trackByFn">
            <span>{{ option?.[optionLabel || 'label'] }}</span>
          </div>
        </ng-template>
      </ng-template>

      <!-- Template per le opzioni nella lista -->
      <ng-template
        #item
        let-option
      >
        <ng-container *ngIf="optionTemplate; else defaultOptionTemplate">
          <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }" />
        </ng-container>
        <ng-template #defaultOptionTemplate>
          <span>{{ option[optionLabel || 'label'] }}</span>
        </ng-template>
      </ng-template>
    </p-multiselect>

    <p-multiselect
      *ngSwitchDefault
      [id]="id"
      [name]="id"
      [optionLabel]="optionLabel"
      [dataKey]="dataKey"
      [options]="options"
      [(ngModel)]="selectedOptions"
      (ngModelChange)="onSelectionChange($event)"
      [placeholder]="placeholder"
      [ngClass]="{
        'ape-multi-select w-full': true,
        'valid': valid,
        'invalid': invalid,
        'read-only': readOnly
      }"
      [disabled]="disabled"
      [variant]="variant"
      [showClear]="showClear"
      [filter]="filter"
      [maxSelectedLabels]="maxSelectedLabels"
      [selectedItemsLabel]="selectedItemsLabel"
      [selectionLimit]="selectionLimit"
      (onPanelHide)="onPanelClosed()"
    >
      <!-- Template per le opzioni selezionate -->
      <ng-template
        #selectedItems
        let-selectedOptions
      >
        <ng-container *ngIf="selectedTemplate; else defaultSelectedTemplate">
          <ng-container *ngTemplateOutlet="selectedTemplate; context: { $implicit: selectedOptions }" />
        </ng-container>
        <ng-template #defaultSelectedTemplate>
          <div *ngFor="let option of selectedOptions; trackBy: trackByFn">
            <span>{{ option?.[optionLabel || 'label'] }}</span>
          </div>
        </ng-template>
      </ng-template>

      <!-- Template per le opzioni nella lista -->
      <ng-template
        #item
        let-option
      >
        <ng-container *ngIf="optionTemplate; else defaultOptionTemplate">
          <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }" />
        </ng-container>
        <ng-template #defaultOptionTemplate>
          <span>{{ option[optionLabel || 'label'] }}</span>
        </ng-template>
      </ng-template>
    </p-multiselect>
  </ng-container>
</ape-input-wrapper>